import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Image, Dimensions } from "react-native";
import DollarCoin from "../../../assets/infosTokens/Dollar_Coin.svg";
import Weight from "../../../assets/infosTokens/Weight.svg";
import Location from "../../../assets/infosTokens/Location.svg";
import Truck from "../../../assets/infosTokens/Truck.svg";
import Notepad from "../../../assets/infosTokens/Notepad.svg";
import Calendar from "../../../assets/infosTokens/Calendar.svg";
import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../../services/api";

const InfoCardLoteAgro = ({ idCoin }) => {
  const [activeData, setActiveData] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(
    Dimensions.get("window").width < 1450
  );

  useEffect(() => {
    const fetchActiveData = async () => {
      if (!idCoin) return;

      const token = await AsyncStorage.getItem("JWT_TOKEN");
      try {
        const response = await api.get(`/actives/${idCoin}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const active = response.data.actives[0];
        setActiveData(active);
      } catch (error) {
        console.error("Error fetching active data:", error);
      }
    };

    fetchActiveData();

    return () => {
      setActiveData(null);
    };
  }, [idCoin]);

  useEffect(() => {
    const handleResize = () => {
      const width = Dimensions.get("window").width;
      setIsSmallScreen(width < 768);
    };

    const subscription = Dimensions.addEventListener("change", handleResize);
    return () => {
      subscription?.remove();
    };
  }, []);

  if (!activeData) {
    return <Text>Loading...</Text>;
  }

  return (
    <View style={[styles.card, { width: isSmallScreen ? "100%" : 310 }]}>
      <Text style={styles.header}>Informações do Lote</Text>
      <View style={styles.contentContainer}>
        <View style={styles.line}>
          <Image source={DollarCoin} style={styles.icon} />
          <Text style={styles.text}>
            <Text style={styles.boldText}>Preço: </Text>
            {`R$${activeData.single_value}`}
          </Text>
        </View>
        <View style={styles.line}>
          <Image source={Weight} style={styles.icon} />
          <Text style={styles.text}>
            <Text style={styles.boldText}>Quantidade: </Text>
            {`${activeData.count}kg`}
          </Text>
        </View>
        <View style={styles.line}>
          <Image source={Location} style={styles.icon} />
          <Text style={styles.text}>
            <Text style={styles.boldText}>Entrega/Retirada: </Text>
            Corupá-SC, ou à combinar
          </Text>
        </View>
        <View style={styles.line}>
          <Image source={Truck} style={styles.icon} />
          <Text style={styles.text}>
            <Text style={styles.boldText}>Logística: </Text>
            CIF
          </Text>
        </View>
        <View style={styles.line}>
          <Image source={Notepad} style={styles.icon} />
          <Text style={styles.text}>
            <Text style={styles.boldText}>Observações: </Text>
            Lote de suínos com média de 90kg cada.
          </Text>
        </View>
        <View style={styles.line}>
          <Image source={Calendar} style={styles.icon} />
          <Text style={styles.text}>
            <Text style={styles.boldText}>Data de inserção: </Text>
            09/10/2024
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    alignSelf: "flex-start",
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 16,
    margin: 16,
    borderWidth: 0.5,
    borderColor: "#FFF",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  header: {
    alignSelf: "flex-start",
    color: "#077A97",
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 12,
  },
  contentContainer: {
    marginTop: 8,
  },
  line: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  icon: {
    marginRight: 8,
    width: 24,
    height: 24,
  },
  text: {
    fontSize: 16,
  },
  boldText: {
    color: "#333",
    fontWeight: "bold",
  },
});

export default InfoCardLoteAgro;
